export const GET_STORAGE = `GET_LOCAL_STORAGE`;
export const DELETE_STORAGE = `DELETE_STORAGE`;
export const NEXT_CARD = `NEXT_CARD`;
export const FLAG_WRONG_ANSWER = `FLAG_WRONG_ANSWER`;
export const FLAG_RIGHT_ANSWER = `FLAG_RIGHT_ANSWER`;
export const TICK = `TICK`;
export const PAUSE_GAME = `PAUSE_GAME`;
export const RESUME_GAME = `RESUME_GAME`;
export const CHANGE_SYMBOLS = `CHANGE_SYMBOLS`;
export const STORAGE_SET = `STORAGE_SET`;
export const STORAGE_UNSET = `STORAGE_UNSET`;
export const EMAIL_ERROR = `EMAIL_ERROR`;
export const PASSWORD_ERROR = `PASSWORD_ERROR`;
export const CLEAR_ERRORS = `CLEAR_ERRORS`;
export const LOGIN_SUCCESS = `LOGIN_SUCCESS`;
export const LOGOUT_SUCCESS = `LOGOUT_SUCCESS`;
export const TOGGLE_MODEL = `TOGGLE_MODEL`;
export const SET_MESSAGE = `SET_MESSAGE`;
export const INIT_NOTES = `INIT_NOTES`;
export const SET_FIRST_NOTES = `SET_FIRST_NOTES`;
